module.exports = __webpack_public_path__ + "static/media/Desktop2.a6061f62.jpg";